import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20eaeb41"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, " Rozliczenia ", -1))
const _hoisted_2 = { class: "data-inputs turbines" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Wiatraki ", -1))
const _hoisted_4 = { class: "data-inputs pv" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Instalacje PV ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "production-data"
}
const _hoisted_9 = { class: "production-data-turbines" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Turbiny", -1))
const _hoisted_11 = { class: "production-data-pv" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "PV", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CFormLabel = _resolveComponent("CFormLabel")!
  const _component_CFormInput = _resolveComponent("CFormInput")!
  const _component_CCol = _resolveComponent("CCol")!
  const _component_CRow = _resolveComponent("CRow")!
  const _component_date_picker_modal_component = _resolveComponent("date-picker-modal-component")!
  const _component_CIcon = _resolveComponent("CIcon")!
  const _component_CWidgetStatsF = _resolveComponent("CWidgetStatsF")!
  const _component_CSpinner = _resolveComponent("CSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_CRow, null, {
        default: _withCtx(() => [
          _createVNode(_component_CCol, { md: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_CFormLabel, { for: "turbine-energy-sell-price" }, {
                default: _withCtx(() => [
                  _createTextVNode("Cena sprzedaży energii")
                ]),
                _: 1
              }),
              _createVNode(_component_CFormInput, {
                type: "number",
                class: "turbine-energy-sell-price",
                modelValue: _ctx.turbines.energyPrice,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.turbines.energyPrice) = $event)),
                min: "0",
                step: "0.01"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_CCol, { md: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_CFormLabel, { for: "turbine-certificates-price" }, {
                default: _withCtx(() => [
                  _createTextVNode("Cena sprzedaży certyfikatów")
                ]),
                _: 1
              }),
              _createVNode(_component_CFormInput, {
                type: "number",
                class: "turbine-certificates-price",
                modelValue: _ctx.turbines.certificatePrice,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.turbines.certificatePrice) = $event)),
                min: "0",
                step: "0.01"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_CRow, null, {
        default: _withCtx(() => [
          _createVNode(_component_CCol, { md: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_CFormLabel, { for: "pv-energy-sell-price" }, {
                default: _withCtx(() => [
                  _createTextVNode("Cena zakupu energii")
                ]),
                _: 1
              }),
              _createVNode(_component_CFormInput, {
                type: "number",
                class: "pv-energy-buy-price",
                modelValue: _ctx.pvEnergyCostData.energyPrice,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pvEnergyCostData.energyPrice) = $event)),
                min: "0",
                step: "0.01"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_CCol, { md: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_CFormLabel, { for: "v-balancing-factor" }, {
                default: _withCtx(() => [
                  _createTextVNode("Prosument bilansowanie(%)")
                ]),
                _: 1
              }),
              _createVNode(_component_CFormInput, {
                type: "number",
                class: "pv-balancing-factor",
                modelValue: _ctx.pvEnergyCostData.balancingFactor,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pvEnergyCostData.balancingFactor) = $event)),
                min: "0",
                step: "1",
                max: "100"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_6,
    _createVNode(_component_date_picker_modal_component, { onPickedDates: _ctx.fetchFromPickedDate }, null, 8, ["onPickedDates"]),
    _hoisted_7,
    (_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_CRow, null, {
              default: _withCtx(() => [
                _createVNode(_component_CCol, { md: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CWidgetStatsF, {
                      color: "success",
                      padding: false,
                      title: "Produkcja",
                      value: _ctx.turbines.totalProduction + 'MWh'
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CIcon, {
                          icon: _ctx.cilBolt,
                          height: "36"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_CCol, { md: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CWidgetStatsF, {
                      color: "primary",
                      padding: false,
                      title: "Przychód",
                      value: _ctx.getTurbinesIncome() + 'zł'
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CIcon, {
                          icon: _ctx.cilMoney,
                          height: "36"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_CRow, { class: "production-data-pv-row" }, {
              default: _withCtx(() => [
                _createVNode(_component_CCol, { md: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CWidgetStatsF, {
                      color: "danger",
                      padding: false,
                      title: "Zużyta energia",
                      value: _ctx.pv.totalUsedPower + 'MWh'
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CIcon, {
                          icon: _ctx.cilIndustry,
                          height: "36"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_CCol, { md: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CWidgetStatsF, {
                      color: "warning",
                      padding: false,
                      title: "Do sieci",
                      value: _ctx.pv.totalPowerToTheGrid/1000 + 'MWh'
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CIcon, {
                          icon: _ctx.cilEco,
                          height: "36"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_CCol, { md: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CWidgetStatsF, {
                      color: "success",
                      padding: false,
                      title: "Produkcja PV",
                      value: _ctx.pv.totalPowerFromPV/1000 + 'MWh'
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CIcon, {
                          icon: _ctx.cilLightbulb,
                          height: "36"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_CRow, null, {
              default: _withCtx(() => [
                _createVNode(_component_CCol, { md: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CWidgetStatsF, {
                      color: "primary",
                      padding: false,
                      title: "Koszty energii",
                      value: _ctx.getPVTotalUsedPowerCost() + 'zł'
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CIcon, {
                          icon: _ctx.cilMoney,
                          height: "36"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_CCol, { md: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CWidgetStatsF, {
                      color: "success",
                      padding: false,
                      title: "Oszczędności",
                      value: _ctx.getPVSavings() + 'zł'
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CIcon, {
                          icon: _ctx.cilMoney,
                          height: "36"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_CSpinner, {
      color: "success",
      class: "spinner"
    }, null, 512), [
      [_vShow, !_ctx.isLoaded]
    ])
  ], 64))
}